import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/member/page', data, {
    trim: true
  })
}

// 查询
export function findAll (data) {
  return request.post('/business/member/findAll', data)
}
export function detail (id) {
  return request.get(`/business/member/${id}`)
}
export function updateShop (data) {
  return request.post('/business/member/updateShop', data)
}
export function updateById (data) {
  return request.post('/business/member/updateById', data)
}
export function exportExcel (data) {
  return request.post('/business/member/exportExcelList', data, {
    trim: true,
    download: true
  })
}
